export default "__VITE_ASSET__D8lKlt75__"